// extracted by mini-css-extract-plugin
export default {"btn":"CategoryButtons_btn__DR9es"};